export enum AndroidAv1Profile {
    Main8 = 1 << 0,
    Main10 = 1 << 1,
    Main10Hdr10 = 1 << 12,
    Main10Hdr10Plus = 1 << 13,
}

export enum AndroidAv1Level {
    Level2 = 1 << 0,
    Level21 = 1 << 1,
    Level22 = 1 << 2,
    Level23 = 1 << 3,
    Level3 = 1 << 4,
    Level31 = 1 << 5,
    Level32 = 1 << 6,
    Level33 = 1 << 7,
    Level4 = 1 << 8,
    Level41 = 1 << 9,
    Level42 = 1 << 10,
    Level43 = 1 << 11,
    Level5 = 1 << 12,
    Level51 = 1 << 13,
    Level52 = 1 << 14,
    Level53 = 1 << 15,
    Level6 = 1 << 16,
    Level61 = 1 << 17,
    Level62 = 1 << 18,
    Level63 = 1 << 19,
    Level7 = 1 << 20,
    Level71 = 1 << 21,
    Level72 = 1 << 22,
    Level73 = 1 << 23,
}
